//Aplicacion-de-activos/frontend/src/index.js
import ReactDOM from "react-dom/client";
import App from "./App";

// 🧱 Importa los estilos corporativos
import "./styles/Variables.css";
import "./styles/Theme.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
